/**
 * CONTEXT AND REDUCER
 *  SCOPE: 
 *  1. STORE/UPDATE FILTER SETTING GLOBALY
 *  2. STORE FILTER RESULT COUNT
 *  3. STORE/UPDATE SORT SETTING GLOBALLY
 */

import {createContext, useContext, useReducer } from "react";

 export const FilterContext         = createContext(null);
 export const FilterDispatchContext =  createContext(null);

 export function FilterProvider({children}) {

    //  initial Filter setting:
    let initFilterSetting = {
        city: [],
        minPrice:"",
        maxPrice:"",
        resultCount: 0,
        sortBy: {type: 'dat', order: 1, locAvailable:false, lat:undefined, lng:undefined, reason:'load'} //db order: 1= asc(increasing), -1=desc(decreasing)
    }

    const [filterSetting, dispatch] = useReducer( filterReducer, initFilterSetting);

    console.log('inside filter contexct')

    return(
        <FilterContext value={filterSetting}> 
            <FilterDispatchContext value={dispatch}>
                {children}
            </FilterDispatchContext>
        </FilterContext>
    )
 }


// reference functions
 export function useFilter()         { return useContext(FilterContext); }
 export function useFilterDispatch() { return useContext(FilterDispatchContext); }


//  Reducer logic:
 function filterReducer(filterSetting,action) {

    let newSetting;

    switch(action.type) {

        case 'upd_City':
            filterSetting.city = action.city;
            // return(filterSetting);
        break;

        case 'upd_price':
            switch(action.range) {

                case 'min':
                    filterSetting = {...filterSetting, minPrice : action['newValue']};
                    // return(filterSetting);
                break;

                case 'max':
                    filterSetting = {...filterSetting, maxPrice : action['newValue'] };
                    // return(filterSetting);
                break;
                default: //
            }
        break;

        case 'upd_sort':
            newSetting = {};
            newSetting.type = action.newValue;
            newSetting.order = action.order;
            filterSetting = {...filterSetting, sortBy: newSetting  };
            // return(filterSetting);
        break;

        case 'all':
            filterSetting = {...filterSetting,
                city : action['oFilterSetting'].city,
                minPrice : action['oFilterSetting'].minPrice,
                maxPrice : action['oFilterSetting'].maxPrice,
                sortBy   : { type : action['oFilterSetting'].sortBy['type'],
                            order: action['oFilterSetting'].sortBy['order'],
                            lat: action['oFilterSetting'].sortBy['lat'],
                            lng: action['oFilterSetting'].sortBy['lng'],
                            locAvailable: action['oFilterSetting'].sortBy['locAvailable']
                            }, 
            }
        // return(filterSetting);

        break;

        case 'reset':
        break;

        case 'getCount':
        break;

        case 'upd_reason':
            filterSetting.reason = action.reason;

        break;

        case 'setCount':
            filterSetting.resultCount = action.resultCount;
            // return(filterSetting)

        break;

        default ://

    }

    return(filterSetting);
 }






















// ****** OLD VERSION WITHOUT REDUCER 

// const FilterContext = createContext();

// function FilterContextProvider({children}) {

//     const [fltrRsltCount,setRsltCount]  = useState(0),
//           [fltrSetting, setFilterSetting] = useState({});

//     const updateRsltCount = (iValue) => {
//         setRsltCount(iValue);
//     }

//     const updateFltrSetting = (oSetting) => {
//         console.log(oSetting,"filter context");
//         setFilterSetting(oSetting);
//         console.log(fltrSetting,"filter state");
//     }

//     return(
//         <FilterContext.Provider value={{fltrRsltCount,fltrSetting,updateRsltCount,updateFltrSetting}}>
//             {children}
//         </FilterContext.Provider>
//     )

// }

// export {FilterContext,FilterContextProvider};